<template>
<div class="container column margins">
    <h1 class="title left" style="margin-left: 0.9em">Facturación electrónica</h1>

    <!-- Show Bill lookup if not yet requested -->
    <div class="container" v-if="!billingOrder || !billingStep">
        <div class="item">
            <form class="login-form" @submit.prevent="FindCFDI" >
                <h1>Generar factura</h1>
                <input type="text" class="form-control left" required="" name="orderNumber" placeholder="Número de orden">
                <input type="date" class="form-control left" required="" name="date" placeholder="dd/mm/aa">
                <input type="text" class="form-control left" required="" name="amount" placeholder="Monto">
                <div class="mid-container">
                    <input class="ui blue button wide" type="submit" value="Continuar" >
                </div>
            </form>
        </div>

        <div class="item">
            <form class="register-form" @submit.prevent="FindCFDI">
                <h1>Buscar factura</h1>
                <input type="text" class="form-control left" required="" name="orderNumber" placeholder="Número de orden"/>
                <input type="date" class="form-control left" required="" name="date" placeholder="dd/mm/aa"/>
                <input type="text" class="form-control left" required="" name="amount" placeholder="Monto"/>
                <div class="mid-container">
                    <input class="ui blue button wide" type="submit" value="Continuar">
                </div>
            </form>
        </div>
    </div>

    <!-- Otherwise, continue with billing flow  -->
    <div v-else-if="billingStep === 'billingInformationLookupStep'">
        <div class="item">
            <form class="register-form" @submit.prevent="FetchBillingInformation">
                <h1>Introduce tus datos</h1>
                <input type="text" class="form-control left" required="" name="rfc" placeholder="Tu RFC"/>
                <input type="text" class="form-control left" required="" name="legalName" placeholder="Nombre legal"/>
                <input type="text" class="form-control left" required="" name="email" placeholder="Email"/>
                <div class="mid-container">
                    <input class="ui blue button wide" type="submit" value="Continuar">
                </div>
            </form>
        </div>
    </div>

    <!-- Verify CFDI use case -->
    <div v-else-if="billingStep === 'cfdiUseCaseStep'">
        <form class="register-form" @submit.prevent="GenerateCFDI">
            <h1>Uso de CFDI</h1>
            <select class="form-control" name="cfdiUse" style="margin-top: 10px" @change="ChangeCFDIUseCase" required>
                <option value="G01">G01 - Adquisición de mercancías</option>
                <option value="G02">G02 - Devoluciones, descuentos o bonificaciones</option>
                <option value="G03">G03 - Gastos en general</option>
                <option value="I01">I01 - Construcciones</option>
                <option value="I02">I02 - Mobiliario y equipo de oficina por inversiones</option>
                <option value="I03">I03 - Equipo de transporte</option>
                <option value="I04">I04 - Equipo de cómputo y accesorios</option>
                <option value="I05">I05 - Dados, troqueles, moldes, matrices y herramental</option>
                <option value="I06">I06 - Comunicaciones telefónicas</option>
                <option value="I07">I07 - Comunicaciones satelitales</option>
                <option value="I08">I08 - Otra maquinaria y equipo</option>
                <option value="D01">D01 - Honorarios médicos, dentales y gastos hospitalarios</option>
                <option value="D02">D02 - Gastos médicos por incapacidad o discapacidad</option>
                <option value="D03">D03 - Gastos funerales</option>
                <option value="D04">D04 - Donativos</option>
                <option value="D05">D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)</option>
                <option value="D06">D06 - Aportaciones voluntarias al SAR</option>
                <option value="D07">D07 - Primas por seguros de gastos médicos</option>
                <option value="D08">D08 - Gastos de transportación escolar obligatoria</option>
                <option value="D09">D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones</option>
                <option value="D10">D10 - Pagos por servicios educativos (colegiaturas)</option>
                <option value="P01">P01 - Por definir</option>
            </select>

            <div v-if="billingCFDIUseCase" style="width: 90%">
                <h1>Verifique sus datos</h1>
                <div class="left" style="width: 90%">
                    <div>RFC: {{billingRfc.rfc}}</div>
                    <div>Razon Social: {{billingRfc.legalName}}</div>
                    <div>Email: {{billingEmail.email}}</div>
                    <div>Monto: ${{billingOrder.orderTotal}}.00</div>
                    <div>Uso: {{billingCFDIUseCase}}</div>
                </div>

                <input class="ui green button wide" data-billing-sync type="submit"  value="Siguiente >" style="margin-top: 10px"/>
            </div>
        </form>
    </div>

    <!-- Show download links -->
    <div v-else-if="billingStep === 'billingDownloadStep'">
        <div class="container column centered cfdi-container">
            <div>
                <!-- If CFDI exists, show leyend indicating so -->
                <div v-if="billingExistingCFDI">
                    <h1 v-if="billingExistingCFDI">Ya tiene un CFDI asociado a esta orden</h1>
                    <form class="ui form wide" @submit.prevent="RequestCFDIEmail" id="CreateCfdiForm">
                        <input type="text" class="form-control left" required name="email" placeholder="Correo electrónico">
                        <input class="ui green button wide" type="submit" value="Enviar por correo" style="margin-top: 10px"/>
                    </form>
                </div>

                <!-- Otherwise show success message -->
                <div v-else>
                    <h1>¡ Creación exitosa !</h1>
                    <span>Descargar como PDF o XML</span>
                </div>

                <div class="container center" style="text-align: center;">
                    <div style="margin-top:10px;">
                        <img class="clickable" src="img/pdf.png" alt="PDF" :data-order="billingOrder.id" data-download-type="pdf" @click="DownloadCFDI" style="max-width: 60px; max-height: 60px;">
                    </div>
                    <div style="margin-top:10px;">
                        <img class="clickable" src="img/xml.png" alt="XML" :data-order="billingOrder.id" data-download-type="xml" @click="DownloadCFDI" style="max-width: 60px; max-height: 60px;">
                    </div>
                </div>
            </div>
            <br>
            <span>Para dudas o problemas con la facturación en línea favor de contactarnos por medio de correo a <a href="mailto:fac@gofarma.com"><b>fac@gofarma.com</b></a></span>
        </div>
    </div>

    <!-- Show email confirmation step -->
    <div v-else-if="billingStep === 'billingEmailSentStep'">
        <div class="container column centered cfdi-container">
            <div>
                <h1>La factura se envío por email</h1>
            </div>
            <br>
            <h4>Para dudas o problemas con la facturación en línea favor de contactarnos por medio de correo a <a href="mailto:fac@gofarma.com">fac@gofarma.com</a></h4>
        </div>
    </div>
</div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name:'electronicBilling',
    methods:{
        ChangeCFDIUseCase( e ){
            this.$store.commit('StateAssign', { 'billingCFDIUseCase': e.target.value });
        },
        ...mapActions(['FindCFDI', 'DownloadCFDI', 'FetchBillingInformation', 'GenerateCFDI', 'RequestCFDIEmail'])
    },
    computed: {
        ...mapState(['billingCFDI', 'billingOrder', 'billingStep', 'billingEmail', 'billingCFDIUseCase', 'billingRfc', 'billingExistingCFDI'])
    },
}
</script>

<style scoped>
@import '../variables.css';

.login-form, .register-form{
    flex-basis: 50%;
    flex-grow: 1;
}
.item{
    display: flex;
    justify-content: center;
    flex-grow: 1;
    align-items: flex-start;
}

.title{
    font-family: Gilroy-Bold, sans-serif;
}

.margins{
    margin: 0 12em 3em 12em
}

.cfdi-container{
    width: 50%
}

@media (max-width: 56.875rem){
    .margins { 
        margin:0;
    }
    .cfdi-container{
        width: 80%;
    }
}

body form {
    background:transparent;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 1.25rem;
    box-sizing: border-box;
    border-radius: 0.625rem
   
}
form h1{
    width: 90%;
    text-align:left;
    color: var(--dark-gofarma);
    font-weight: bold;
}
.form-control {
    width: 90%;
    min-height:2rem;
    padding: 0.312rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom:1em;
    text-align: center;
    box-sizing: border-box;
  
}

.btn-positive {
    border-color: var(--strong-green) var(--strong-green) var(--strong-green);
    background-color:  var(--light-green);
    width: 90%;
}
.btn-primary {
    border-color: var(--blue-gofarma) var(--blue-gofarma) var(--blue-gofarma);
    background-color: var(--blue-gofarma);
    width: 90%;
}
.btn {
    display: inline-block;
    padding: 0.1875rem 0.5rem;
    margin-bottom: 0;
    line-height: 1.4;
    white-space: nowrap;
    background-image: none;
    border: 0.0625rem solid transparent;
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.0625rem rgba(0,0,0,.06);
}
.btn {
    vertical-align: middle;
    -webkit-app-region: no-drag;
}

.btn-negative, .btn-positive, .btn-primary, .btn-warning {
    color: #fff;
    text-shadow: 0 0.0625rem 0.0625rem  rgba(0,0,0,.1);
}
</style>